import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'

export default ({ style, children, closable = true, closeIcon, className, prefixCls, duration = 1.5, onClose }) => {
  const closeTimer = useRef()
  const close = () => {
    clearCloseTimer()
    onClose?.()
  }
  const clearCloseTimer = () => {
    if (duration) {
      clearTimeout(closeTimer.current)
    }
  }

  const startCloseTimer = () => {
    if (duration) {
      closeTimer.current = setTimeout(() => {
        close()
      }, duration * 1000)
    }
  }

  const restartCloseTimer = () => {
    clearCloseTimer()
    startCloseTimer()
  }

  useEffect(() => {
    if (duration) {
      restartCloseTimer()
    }
    return () => {
      clearCloseTimer()
    }
  }, [duration])

  return <div
    className={classNames(`${prefixCls}-notification-notice`, className)}
    style={style}
    onMouseEnter={clearCloseTimer}
    onMouseLeave={startCloseTimer}
  >
    <div className={`${prefixCls}-notification-content`}>{children}</div>
    {closable
      ? <a
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex="0"
          onClick={close}
          className={`${prefixCls}-notification-notice-close`}
      >
        {closeIcon || <span className={`${prefixCls}-notification-close-x`}>X</span>}
      </a> : null}
  </div>
}
